const pagesPersonCertificationEn = {
  detail: {
    body: {
      errors: {
        certificationIdLabel: 'Person certification ID: {{id}}',
        certificationNotFound: 'Person certification details not found',
        dataLoadFailed: 'Failed to load data',
        unknownError: 'An unknown error occurred'
      }
    },
    tabs: {
      detail: 'Detail'
    }
  },
  status: {
    ACTIVE: 'Active',
    APPLYING: 'Applying',
    EXPIRED: 'Expired',
    REVOKED: 'Revoked',
    SUSPENDED: 'Suspended'
  }
};
export default pagesPersonCertificationEn;